import {Constants} from './actions'


const initialState = {
  requesting: false,
  successful: false,
  tokenIsLive: true
}


const reducer = function globalReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.GET_DATA:
      return {
        ...state,
        requesting: true,
        successful: false,
      }
    case Constants.SET_DATA:
      return {
        ...state,
        requesting: false,
        successful: true,
        tokenIsLive: action.payload
      }
    default:
      return state
  }
}

export default reducer


// WEBPACK FOOTER //
// ./src/containers/Full/reducer.js